// extracted by mini-css-extract-plugin
export default {"revenueSection":"SubTabPlan4_revenueSection__Mv1tI","subTabPlan4Form":"SubTabPlan4_subTabPlan4Form__id7+D"};